export default "__VITE_ASSET__C5MPc00i__"